module.exports = __webpack_public_path__ + "static/img/12.4e3e6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/12.png
// module id = Pg+F
// module chunks = 0